import React from 'react'
import './Social.scss'
import {
  TwitterButton,
  FacebookButton,
  GooglePlusButton,
  LinkedInButton,
  TumblrButton,
  RedditButton,
  XingButton,
  EmailButton,
  VKontakteButton,
  PinterestButton
} from 'react-social'
import Setting from '../../containers/SettingContainer'

class Social extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.state = {
      clicked: 'clickstate'
    }
  }

  isBrowser () {
    return !(typeof document === 'undefined' || typeof window === 'undefined')
  }

  handleClick () {
    if (this.state.clicked === 'clickstate') {
      this.setState(() => {
        return { clicked: 'basestate' }
      })
    } else {
      this.setState(() => {
        return { clicked: 'clickstate' }
      })
    }
  }

  render () {
    let link = ''
    if (this.isBrowser()) { link = window.location.href }
    let message = 'Chia sẻ'
    const classWH = {
      width: '25px',
      height: '25px',
      color: 'cornflowerblue',
      marginTop: '10px'
    }

    return (
      <div className={this.state.clicked} id='buttons' onClick={this.handleClick}>
        <span>
          <i className='Close glyphicon glyphicon-chevron-down' />
          Chia sẻ
        </span>
        <div>
          <FacebookButton style={classWH} title='Share via Facebook' message={message} appId={Setting.chatFBappId}
            url={link} >
            <i className='fa fa-facebook-square' />
          </FacebookButton>
          <TwitterButton style={classWH} title='Share via Twitter' message={message} url={link} >
            <i className='fa fa-twitter-square' />
          </TwitterButton>
          <GooglePlusButton style={classWH} title='Share via Google+' message={message} url={link} >
            <i className='fa fa-google-plus-square' />
          </GooglePlusButton>
          <PinterestButton style={classWH} title='Share via Pinterest' message={message} url={link} >
            <i className='fa fa-pinteres-square' />
          </PinterestButton>
          <LinkedInButton style={classWH} title='Share via Linkedin' message={message} url={link} >
            <i className='fa fa-linkedin-square' />
          </LinkedInButton>
          <RedditButton style={classWH} title='Share via Reddit' message={message} url={link} >
            <i className='fa fa-reddit-square' />
          </RedditButton>
          <VKontakteButton style={classWH} title='Share via VKontakte' message={message} url={link} >
            <i className='fa fa-vk' />
          </VKontakteButton>
          <EmailButton style={classWH} title='Share via E-Mail' message={message} url={link} >
            <i className='fa fa-at' />
          </EmailButton>
          <XingButton style={classWH} title='Share via Xing' message={message} url={link} >
            <i className='fa fa-xing' />
          </XingButton>
          <TumblrButton style={classWH} title='Share via Tumblr' message={message} url={link} >
            <i className='fa fa-tumblr' />
          </TumblrButton>
        </div>
      </div>
    )
  }
}
export default Social



// WEBPACK FOOTER //
// ./src/components/_partial/Social.js